import React from 'react';

import { Container } from './styles';

const ErrorMessage: React.FC = ({children}) => {
  return <Container>{children}</Container>;
}

export default ErrorMessage;